
export default {
	$newFashion:true,
}